export class OrderedTaskStepUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get step() {
        return this.parent;
    }
    get task() {
        return this.step.task;
    }
    get shouldShowTemporaryFalseFeedback_1500ms() {
        if (this.step.stepProgress.isStepCompleted)
            return false;
        if (!this.step.stepState.latestSelectionEvent)
            return false;
        if (this.step.stepEval.isNowCorrectlySelected)
            return false;
        return (this.step.context.app.appClock.clock_250.tickingTime <= this.step.stepState.latestSelectionEvent.appTime + 1500);
    }
}
